import { getBaseURL } from "../../env/stage";
import { GET_BACKUP, LIST_BACKUPS_FOR_FLOW, SAVE_FLOW, SAVE_FLOW_ONLY, GET_ALL_FLOWS_WITH_BACKUPS, GET_BACKUP_TOKEN } from "./types";
import { get, post, del } from "../../common/modules/http.client";
import { addMessage } from "./messageActions";

const APP_URL = getBaseURL();

export const getBackupToken = () => (dispatch: any) => {
  get(APP_URL + "/backup/token")
    .then((res) => {
      dispatch({
        type: GET_BACKUP_TOKEN,
        payload: res,
      });
    })
    .catch((err) => {
      console.log("err", err);
      dispatch(addMessage("Error getting backup token", err.statusText, "error"));
    });
};

export const listBackupsForType = (objectType: string, objectId: string) => (dispatch: any) => {
  get(APP_URL + "/backups" + `?objectType=${objectType}&objectId=${objectId}`)
    .then((res) => {
      dispatch({
        type: LIST_BACKUPS_FOR_FLOW,
        payload: res,
      });
    })
    .catch((err) => {
      console.log("err", err);
      dispatch(addMessage("Error getting backups", err.statusText, "error"));
    });
};

export const restoreBackup = (filePath: string) => (dispatch: any) => {
  get(APP_URL + "/restore" + `?filePath=${filePath}`)
    .then((res) => {
      dispatch(addMessage("Restoring in progress", "The content is soon to be updated", "info"));

      dispatch({
        type: SAVE_FLOW,
        payload: res,
      });
    })
    .catch((err) => {
      console.log("err", err);
      dispatch(addMessage("Error getting backups", err.statusText, "error"));
    });
};

export const getBackupFile = (filePath: string) => (dispatch: any) => {
  get(APP_URL + "/backup/download" + `?filePath=${filePath}`)
    .then((res) => {
      dispatch({
        type: GET_BACKUP,
        payload: res,
      });
    })
    .catch((err) => {
      console.log("err", err);
      dispatch(addMessage("Error getting backups", err.statusText, "error"));
    });
};
export const doBackup = (objectType: string, objectId: string, backupMessage: string) => (dispatch: any) => {
  post(APP_URL + "/backup" + `?objectType=${objectType}&objectId=${objectId}`);
  dispatch(addMessage("Backup in progress", backupMessage, "info"));
};

export const restoreBackupFromFile = (flowContent: string) => (dispatch: any) => {
  post(APP_URL + "/restore", JSON.parse(flowContent))
    .then((res) => {
      dispatch({
        type: SAVE_FLOW_ONLY,
        payload: res,
      });
      dispatch(addMessage("Restoring done", "Restoring completed", "success"));
    })
    .catch((err) => {
      console.log("err", err);
      dispatch(addMessage("Error getting backups", err.statusText, "error"));
    });
};
export const listAllFlowsWithBackup = () => (dispatch: any) => {
  get(APP_URL + "/customer/backups" + `?objectType=flow`)
    .then((res) => {
      dispatch({
        type: GET_ALL_FLOWS_WITH_BACKUPS,
        payload: res,
      });
    })
    .catch((err) => {
      console.log("err", err);
      dispatch(addMessage("Error getting backups", err.statusText, "error"));
    });
};

export const deleteBackupFile = (filePath: string, globalList: boolean) => (dispatch: any, getState: any) => {
  const EVENT_DISPATCH = globalList ? GET_ALL_FLOWS_WITH_BACKUPS : LIST_BACKUPS_FOR_FLOW;
  const state = getState();

  // Get the current list depending on globalList
  const currentList = globalList ? state.backups.allFlowsWithBackup : state.backups.flowBackups;

  del(APP_URL + "/backup" + `?filePath=${filePath}`)
    .then(() => {
      const updatedList = currentList.filter((item: string) => item !== filePath);

      dispatch({
        type: EVENT_DISPATCH,
        payload: updatedList,
      });
    })
    .catch((err) => {
      console.log("err", err);
      dispatch(addMessage("Error deleting backup", err.statusText, "error"));
    });
};
